var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWholesaleSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 465,
    viewBox: "0 0 256 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_1107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3871 464.818H203.613C232.46 464.818 255.845 441.682 255.845 413.144L255.845 52.798C255.845 24.2593 232.46 1.12418 203.613 1.12418H52.3871C23.5402 1.12418 0.155136 24.2593 0.155136 52.798L0.155136 413.144C0.155136 441.682 23.5402 464.818 52.3871 464.818Z",
    fill: "url(#paint0_linear_157_1107)",
    stroke: "url(#paint1_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.739 57.2346V180.993C19.6801 188.685 29.45 195.379 39.8722 200.954C119.272 243.356 200.724 199.669 234.277 240.228C238.306 245.119 243.46 253.413 245.419 267.1V371.285C245.421 375.001 244.954 378.702 244.031 382.304C244.998 378.624 245.487 374.836 245.484 371.033V57.2346C245.481 45.3974 240.726 34.046 232.265 25.6762C223.804 17.3063 212.33 12.6031 200.365 12.6007H55.8643C43.8982 12.6015 32.4223 17.304 23.9601 25.674C15.4979 34.0441 10.7423 45.3964 10.739 57.2346Z",
    fill: "url(#paint2_linear_157_1107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.275 32.1474H209.61C213.382 32.1474 217 33.6298 219.667 36.2686C222.334 38.9073 223.833 42.4862 223.833 46.2179V294.662H156.269V32.1474H156.275Z",
    fill: "#151529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.037 38.3472C167.69 38.3472 162.544 43.4374 162.544 49.7165C162.544 55.9956 167.69 61.0856 174.037 61.0856C180.383 61.0856 185.529 55.9956 185.529 49.7165C185.529 43.4374 180.383 38.3472 174.037 38.3472Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.811 71.4186C169.965 71.4186 170.9 70.4934 170.9 69.352C170.9 68.2107 169.965 67.2855 168.811 67.2855C167.658 67.2855 166.722 68.2107 166.722 69.352C166.722 70.4934 167.658 71.4186 168.811 71.4186Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.133 88.6473C145.133 57.4433 119.564 32.1474 88.0224 32.1474C56.4813 32.1474 30.9121 57.4433 30.9121 88.6473C30.9121 119.851 56.4813 145.147 88.0224 145.147C119.564 145.147 145.133 119.851 145.133 88.6473Z",
    fill: "url(#paint3_linear_157_1107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.811 70.0419V197.511",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.811 69.3521V191.308",
    stroke: "url(#paint4_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.259 70.0419V135.844",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.937 48.6831V114.483",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.259 71.4186C180.413 71.4186 181.348 70.4934 181.348 69.352C181.348 68.2107 180.413 67.2855 179.259 67.2855C178.105 67.2855 177.17 68.2107 177.17 69.352C177.17 70.4934 178.105 71.4186 179.259 71.4186Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.361 49.1982H203.982",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.214 136.016H191.445",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.666 51.2648C193.82 51.2648 194.755 50.3396 194.755 49.1982C194.755 48.0569 193.82 47.1317 192.666 47.1317C191.513 47.1317 190.577 48.0569 190.577 49.1982C190.577 50.3396 191.513 51.2648 192.666 51.2648Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.054 206.12V75.1255C190.054 72.9551 190.925 70.8736 192.476 69.3389C194.028 67.8042 196.132 66.942 198.326 66.942H206.278C207.44 66.942 208.59 67.1684 209.663 67.6082C210.736 68.048 211.712 68.6925 212.533 69.5051C213.354 70.3177 214.006 71.2823 214.45 72.3439C214.895 73.4056 215.124 74.5436 215.124 75.6928V206.12H190.051H190.054Z",
    fill: "url(#paint5_linear_157_1107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3756 156.86L18.3756 199.577H145.133V156.86H18.3756Z",
    fill: "#151529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.595 163.749C129.518 163.749 127.024 166.217 127.024 169.261C127.024 172.305 129.518 174.772 132.595 174.772C135.671 174.772 138.166 172.305 138.166 169.261C138.166 166.217 135.671 163.749 132.595 163.749Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.689 163.136C110.612 163.136 108.118 165.604 108.118 168.648C108.118 171.691 110.612 174.159 113.689 174.159C116.766 174.159 119.26 171.691 119.26 168.648C119.26 165.604 116.766 163.136 113.689 163.136Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7133 163.136C92.6365 163.136 90.1423 165.604 90.1423 168.648C90.1423 171.691 92.6365 174.159 95.7133 174.159C98.79 174.159 101.284 171.691 101.284 168.648C101.284 165.604 98.79 163.136 95.7133 163.136Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1879 163.136C73.1111 163.136 70.6169 165.604 70.6169 168.648C70.6169 171.691 73.1111 174.159 76.1879 174.159C79.2646 174.159 81.7588 171.691 81.7588 168.648C81.7588 165.604 79.2646 163.136 76.1879 163.136Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2824 163.136C54.2056 163.136 51.7114 165.604 51.7114 168.648C51.7114 171.691 54.2056 174.159 57.2824 174.159C60.3591 174.159 62.8533 171.691 62.8533 168.648C62.8533 165.604 60.3591 163.136 57.2824 163.136Z",
    fill: "#28294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.797 229.245C235.024 234.611 241.756 244.849 245.422 262.262V404.224C245.422 431.075 225.218 452.844 200.297 452.844H55.7993C51.648 452.81 47.5248 452.168 43.5633 450.94C36.04 448.574 29.2628 444.323 23.8891 438.602C11.5819 425.436 10.7669 408.315 10.674 404.224C10.6863 317.383 10.6997 230.54 10.7142 143.697C13.0263 148.873 18.1524 159.218 27.4317 169.21C82.0688 228.044 186.353 172.862 230.797 229.245Z",
    fill: "url(#paint6_linear_157_1107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.422 260.765V266.018C243.665 256.326 239.723 242.359 229.653 230.352C210.881 207.969 181.751 202.42 133.728 201.665C66.2409 200.608 44.2173 190.391 26.3438 170.391C17.9478 160.999 13.3269 150.893 10.7142 143.715V142.964C15.0023 152.417 20.7753 161.138 27.8191 168.806C27.8191 168.806 34.154 175.922 41.9486 181.236C58.7157 192.663 83.169 198.627 133.758 199.421C181.652 200.172 212.396 205.553 231.246 228.902C240.113 239.879 243.755 252.242 245.422 260.765Z",
    fill: "url(#paint7_linear_157_1107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.811 70.3853C169.388 70.3853 169.856 69.9227 169.856 69.352C169.856 68.7813 169.388 68.3187 168.811 68.3187C168.234 68.3187 167.767 68.7813 167.767 69.352C167.767 69.9227 168.234 70.3853 168.811 70.3853Z",
    fill: "#B0AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.259 70.3853C179.836 70.3853 180.303 69.9227 180.303 69.352C180.303 68.7813 179.836 68.3187 179.259 68.3187C178.682 68.3187 178.214 68.7813 178.214 69.352C178.214 69.9227 178.682 70.3853 179.259 70.3853Z",
    fill: "#B0AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.666 50.2316C193.243 50.2316 193.711 49.7689 193.711 49.1983C193.711 48.6276 193.243 48.165 192.666 48.165C192.089 48.165 191.622 48.6276 191.622 49.1983C191.622 49.7689 192.089 50.2316 192.666 50.2316Z",
    fill: "#B0AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.259 69.3521V136.016H190.054",
    stroke: "url(#paint8_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.937 66.942V49.1982H192.666",
    stroke: "url(#paint9_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3706 136.531C80.1497 136.532 73.9897 135.32 68.2423 132.965C62.4948 130.61 57.2724 127.158 52.8735 122.807C48.4745 118.455 44.985 113.289 42.6043 107.603C40.2235 101.917 38.9982 95.8227 38.9982 89.6683V87.6232C38.9982 81.4688 40.2235 75.3747 42.6043 69.6888C44.985 64.0029 48.4745 58.8366 52.8735 54.485C57.2724 50.1333 62.4948 46.6815 68.2423 44.3265C73.9897 41.9716 80.1497 40.7598 86.3706 40.7602H88.4348C94.6556 40.7598 100.816 41.9716 106.563 44.3265C112.311 46.6815 117.533 50.1333 121.932 54.485C126.331 58.8366 129.82 64.0029 132.201 69.6888C134.582 75.3747 135.807 81.4688 135.807 87.6232C135.807 94.0459 134.528 100.406 132.044 106.34C129.56 112.273 125.918 117.665 121.327 122.206C116.737 126.748 111.287 130.351 105.289 132.808C99.2913 135.266 92.8627 136.531 86.3706 136.531Z",
    stroke: "url(#paint10_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.081 437.989C138.614 437.989 147.154 429.541 147.154 419.12C147.154 408.699 138.614 400.251 128.081 400.251C117.547 400.251 109.008 408.699 109.008 419.12C109.008 429.541 117.547 437.989 128.081 437.989Z",
    fill: "url(#paint11_linear_157_1107)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 244.208H36.3172C34.2341 244.208 32.5454 245.879 32.5454 247.94V261.836C32.5454 263.896 34.2341 265.567 36.3172 265.567H216.435C218.518 265.567 220.206 263.896 220.206 261.836V247.94C220.206 245.879 218.518 244.208 216.435 244.208Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.435 244.208H36.3172C34.2341 244.208 32.5454 245.879 32.5454 247.94V261.836C32.5454 263.896 34.2341 265.567 36.3172 265.567H216.435C218.518 265.567 220.206 263.896 220.206 261.836V247.94C220.206 245.879 218.518 244.208 216.435 244.208Z",
    stroke: "url(#paint12_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.294 360.415H38.1768C36.0937 360.415 34.405 362.086 34.405 364.147V378.042C34.405 380.103 36.0937 381.774 38.1768 381.774H218.294C220.377 381.774 222.066 380.103 222.066 378.042V364.147C222.066 362.086 220.377 360.415 218.294 360.415Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.294 360.415H38.1768C36.0937 360.415 34.405 362.086 34.405 364.147V378.042C34.405 380.103 36.0937 381.774 38.1768 381.774H218.294C220.377 381.774 222.066 380.103 222.066 378.042V364.147C222.066 362.086 220.377 360.415 218.294 360.415Z",
    stroke: "url(#paint13_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.432 278.457H37.8359C35.7528 278.457 34.0641 280.128 34.0641 282.189V342.487C34.0641 344.548 35.7528 346.219 37.8359 346.219H216.432C218.515 346.219 220.203 344.548 220.203 342.487V282.189C220.203 280.128 218.515 278.457 216.432 278.457Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.432 278.457H37.8359C35.7528 278.457 34.0641 280.128 34.0641 282.189V342.487C34.0641 344.548 35.7528 346.219 37.8359 346.219H216.432C218.515 346.219 220.203 344.548 220.203 342.487V282.189C220.203 280.128 218.515 278.457 216.432 278.457Z",
    stroke: "url(#paint14_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0345 260.085C46.7937 260.085 49.0305 257.831 49.0305 255.05C49.0305 252.27 46.7937 250.016 44.0345 250.016C41.2753 250.016 39.0385 252.27 39.0385 255.05C39.0385 257.831 41.2753 260.085 44.0345 260.085Z",
    fill: "#7461F2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0805 259.778C63.8397 259.778 66.0765 257.524 66.0765 254.744C66.0765 251.963 63.8397 249.709 61.0805 249.709C58.3213 249.709 56.0845 251.963 56.0845 254.744C56.0845 257.524 58.3213 259.778 61.0805 259.778Z",
    fill: "#7461F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.566 428.462C179.336 428.462 184.013 423.835 184.013 418.126C184.013 412.418 179.336 407.79 173.566 407.79C167.795 407.79 163.118 412.418 163.118 418.126C163.118 423.835 167.795 428.462 173.566 428.462Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.566 428.462C179.336 428.462 184.013 423.835 184.013 418.126C184.013 412.418 179.336 407.79 173.566 407.79C167.795 407.79 163.118 412.418 163.118 418.126C163.118 423.835 167.795 428.462 173.566 428.462Z",
    stroke: "url(#paint15_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.905 419.96H172.961C173.363 419.96 173.76 419.882 174.131 419.73C174.502 419.579 174.839 419.356 175.123 419.075C175.407 418.794 175.632 418.461 175.785 418.094C175.939 417.727 176.017 417.334 176.017 416.936C176.017 416.539 175.939 416.146 175.785 415.779C175.632 415.412 175.407 415.079 175.123 414.798C174.839 414.517 174.502 414.294 174.131 414.143C173.76 413.991 173.363 413.913 172.961 413.913C172.56 413.913 172.162 413.991 171.791 414.143C171.42 414.294 171.083 414.517 170.799 414.798C170.515 415.079 170.29 415.412 170.137 415.779C169.984 416.146 169.905 416.539 169.905 416.936V419.96Z",
    fill: "#7461F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.455 421.37H174.545C173.773 421.37 173.033 421.067 172.487 420.527C171.941 419.987 171.635 419.255 171.635 418.491C171.634 418.113 171.709 417.738 171.855 417.389C172.001 417.039 172.216 416.722 172.486 416.454C172.756 416.187 173.077 415.975 173.431 415.83C173.784 415.686 174.162 415.612 174.545 415.612C174.927 415.612 175.306 415.686 175.659 415.83C176.012 415.975 176.333 416.187 176.604 416.454C176.874 416.722 177.088 417.039 177.234 417.389C177.38 417.738 177.455 418.113 177.455 418.491V421.37Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.389 428.462C214.159 428.462 218.837 423.835 218.837 418.126C218.837 412.418 214.159 407.79 208.389 407.79C202.619 407.79 197.941 412.418 197.941 418.126C197.941 423.835 202.619 428.462 208.389 428.462Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.389 428.462C214.159 428.462 218.837 423.835 218.837 418.126C218.837 412.418 214.159 407.79 208.389 407.79C202.619 407.79 197.941 412.418 197.941 418.126C197.941 423.835 202.619 428.462 208.389 428.462Z",
    stroke: "url(#paint16_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.07 422.376H208.348C209.217 422.376 210.051 422.034 210.665 421.427C211.279 420.819 211.625 419.995 211.625 419.135C211.625 418.275 211.279 417.451 210.665 416.843C210.051 416.236 209.217 415.894 208.348 415.894C207.479 415.894 206.646 416.235 206.031 416.843C205.416 417.451 205.07 418.275 205.07 419.135V422.376Z",
    fill: "#7461F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.373 415.738C209.397 415.738 210.227 414.917 210.227 413.904C210.227 412.891 209.397 412.071 208.373 412.071C207.35 412.071 206.52 412.891 206.52 413.904C206.52 414.917 207.35 415.738 208.373 415.738Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1918 428.465C89.9619 428.465 94.6394 423.838 94.6394 418.129C94.6394 412.421 89.9619 407.793 84.1918 407.793C78.4217 407.793 73.7441 412.421 73.7441 418.129C73.7441 423.838 78.4217 428.465 84.1918 428.465Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1918 428.465C89.9619 428.465 94.6394 423.838 94.6394 418.129C94.6394 412.421 89.9619 407.793 84.1918 407.793C78.4217 407.793 73.7441 412.421 73.7441 418.129C73.7441 423.838 78.4217 428.465 84.1918 428.465Z",
    stroke: "url(#paint17_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M86.6526 415.747V414.37H80.3548V415.747H86.6526Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7104 417.813V416.437H80.3517V417.813H88.7104Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M88.0162 419.883V418.506H80.3548V419.883H88.0162Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M86.6216 421.95V420.573H80.3549V421.95H86.6216Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2691 428.462C52.0391 428.462 56.7167 423.835 56.7167 418.126C56.7167 412.418 52.0391 407.79 46.2691 407.79C40.499 407.79 35.8214 412.418 35.8214 418.126C35.8214 423.835 40.499 428.462 46.2691 428.462Z",
    fill: "#E3E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2691 428.462C52.0391 428.462 56.7167 423.835 56.7167 418.126C56.7167 412.418 52.0391 407.79 46.2691 407.79C40.499 407.79 35.8214 412.418 35.8214 418.126C35.8214 423.835 40.499 428.462 46.2691 428.462Z",
    stroke: "url(#paint18_linear_157_1107)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M50.8405 421.398V420.708H45.9653V421.398H50.8405Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6824 414.92L41.8738 415.72L45.1567 418.968L45.9653 418.168L42.6824 414.92Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9644 418.242L45.1558 417.442L41.8729 420.69L42.6815 421.49L45.9644 418.242Z",
    fill: "#7461F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.7616 88.7761C76.5188 88.7761 79.5645 85.7629 79.5645 82.0459C79.5645 78.3289 76.5188 75.3157 72.7616 75.3157C69.0045 75.3157 65.9587 78.3289 65.9587 82.0459C65.9587 85.7629 69.0045 88.7761 72.7616 88.7761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7397 102.663H88.5432C88.0829 102.663 87.6414 102.482 87.3159 102.16C86.9905 101.838 86.8076 101.401 86.8076 100.946V100.774C86.8076 100.317 86.991 99.878 87.3176 99.5543C87.6442 99.2307 88.0872 99.0485 88.5494 99.0476H95.7583C101.532 99.0476 106.352 94.5128 106.438 88.8006C106.457 87.4215 106.199 86.0526 105.678 84.773C105.158 83.4934 104.387 82.3287 103.408 81.3462C102.43 80.3638 101.264 79.5831 99.9788 79.0496C98.6933 78.516 97.3135 78.24 95.9194 78.2377H88.7633C88.2947 78.2377 87.8453 78.0536 87.514 77.7258C87.1827 77.3981 86.9966 76.9535 86.9966 76.49V74.6288H95.9194C97.7913 74.6308 99.6443 74.9993 101.371 75.7132C103.099 76.427 104.666 77.4721 105.983 78.7881C107.3 80.1041 108.341 81.6651 109.045 83.3809C109.749 85.0967 110.103 86.9334 110.086 88.7852C110.012 96.4997 103.537 102.663 95.7397 102.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5111 89.9167H80.392C79.9084 89.9167 79.4446 89.7268 79.1024 89.3888C78.7601 89.0508 78.5673 88.5922 78.5665 88.1138C78.5665 87.6348 78.759 87.1754 79.1013 86.8367C79.4437 86.4981 79.9079 86.3078 80.392 86.3078H88.6888C89.1724 86.3086 89.636 86.4992 89.9777 86.8378C90.3194 87.1764 90.5111 87.6353 90.5111 88.1138V89.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.094 96.3525H84.0648C83.5814 96.3525 83.1179 96.1625 82.7762 95.8244C82.4344 95.4863 82.2424 95.0278 82.2424 94.5496C82.2424 94.0714 82.4344 93.6129 82.7762 93.2748C83.1179 92.9366 83.5814 92.7467 84.0648 92.7467H92.2716C92.511 92.7467 92.7479 92.7933 92.969 92.8839C93.1901 92.9745 93.391 93.1073 93.5602 93.2748C93.7295 93.4422 93.8638 93.6409 93.9554 93.8597C94.0469 94.0784 94.094 94.3128 94.094 94.5496V96.3525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0616 83.7997H72.6748C72.1894 83.8065 71.7206 83.6252 71.3685 83.2946C71.0164 82.9641 70.809 82.5104 70.7904 82.0305C70.7855 81.7907 70.8289 81.5523 70.9183 81.3293C71.0077 81.1063 71.1411 80.9032 71.3108 80.7319C71.4806 80.5605 71.6832 80.4244 71.9068 80.3315C72.1304 80.2386 72.3703 80.1908 72.6128 80.1909H85.2238C85.7074 80.1909 86.1712 80.3807 86.5135 80.7187C86.8557 81.0567 87.0484 81.5153 87.0492 81.9938L87.0616 83.7997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M72.675 84.2413C72.0736 84.2464 71.4939 84.0193 71.0592 83.6082C70.6245 83.197 70.3693 82.6343 70.3475 82.0398C70.3421 81.7419 70.3966 81.4461 70.508 81.1693C70.6195 80.8926 70.7855 80.6406 70.9964 80.428C71.2073 80.2154 71.4589 80.0464 71.7364 79.931C72.0139 79.8155 72.3118 79.7558 72.6129 79.7555H76.4375C75.9331 78.9644 75.1813 78.358 74.2965 78.0285C73.4117 77.699 72.4422 77.6644 71.5357 77.93C70.6292 78.1955 69.8352 78.7468 69.2744 79.4998C68.7136 80.2528 68.4169 81.1664 68.4292 82.1016C68.4415 83.0369 68.7621 83.9426 69.3425 84.6809C69.9228 85.4193 70.7311 85.9499 71.6442 86.1921C72.5574 86.4343 73.5255 86.3748 74.4014 86.0226C75.2772 85.6705 76.0129 85.045 76.4964 84.2413H72.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.081 432.736C135.682 432.736 141.844 426.64 141.844 419.12C141.844 411.599 135.682 405.503 128.081 405.503C120.479 405.503 114.317 411.599 114.317 419.12C114.317 426.64 120.479 432.736 128.081 432.736Z",
    fill: "url(#paint19_linear_157_1107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.251 45.1384C178.51 45.1384 178.72 45.3486 178.72 45.6079V52.1815C178.72 52.4408 178.51 52.651 178.251 52.651H171.44L169.354 54.2944V45.6079C169.354 45.3486 169.563 45.1384 169.822 45.1384H178.251ZM174.505 47.0165H173.568V50.7729H174.505V47.0165ZM176.378 47.9556H175.442V50.7729H176.378V47.9556ZM172.632 48.8947H171.695V50.7729H172.632V48.8947Z",
    fill: "#ABA6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.041 413.206C134.395 413.206 134.682 413.494 134.682 413.848V422.836C134.682 423.191 134.395 423.478 134.041 423.478H124.729L121.876 425.725V413.848C121.876 413.494 122.163 413.206 122.516 413.206H134.041ZM128.919 415.774H127.639V420.91H128.919V415.774ZM131.48 417.058H130.2V420.91H131.48V417.058ZM126.358 418.342H125.078V420.91H126.358V418.342Z",
    fill: "#D6D4FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_1107",
    x1: -16.4725,
    y1: 485.45,
    x2: 245.943,
    y2: 16.8916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DBEB",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CDCFE6",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C6C7E2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C3C4E1",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_157_1107",
    x1: 128,
    y1: 464.971,
    x2: 128,
    y2: 0.967811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C3C4E1",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_157_1107",
    x1: 130.346,
    y1: -49.5654,
    x2: 128.302,
    y2: 197.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E2E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_157_1107",
    x1: 128.908,
    y1: 135.823,
    x2: 36.4215,
    y2: 26.7836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#242243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#262447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2D2B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#383669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#43427F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_157_1107",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_157_1107",
    x1: 205.349,
    y1: 87.1785,
    x2: 199.157,
    y2: 209.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E2E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_157_1107",
    x1: 228.788,
    y1: 458.977,
    x2: -45.2503,
    y2: 114.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D8DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D6D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C0C3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ADB0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#9B9EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_157_1107",
    x1: -15.735,
    y1: 137.135,
    x2: 231.795,
    y2: 246.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D8DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D8DBEB",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D9DCEC",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DBDEED",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#DEE1EE",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E2E4F0",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E7E8F2",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ECEEF5",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F2F3F9",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F9FAFC",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_157_1107",
    x1: 184.577,
    y1: 136.17,
    x2: 184.577,
    y2: 69.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_157_1107",
    x1: 197.879,
    y1: 66.942,
    x2: 197.879,
    y2: 49.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_157_1107",
    x1: 87.4027,
    y1: 136.531,
    x2: 87.4027,
    y2: 40.7602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#5C5CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7A78C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#928EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A39EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ADA7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_157_1107",
    x1: 127.83,
    y1: 392,
    x2: 128.315,
    y2: 445.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#35355E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2D2D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1F1F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_157_1107",
    x1: 126.376,
    y1: 244.211,
    x2: 126.376,
    y2: 265.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_157_1107",
    x1: 128.236,
    y1: 360.418,
    x2: 128.236,
    y2: 381.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_157_1107",
    x1: 127.135,
    y1: 278.457,
    x2: 127.135,
    y2: 346.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_157_1107",
    x1: 179.909,
    y1: 409.652,
    x2: 167.546,
    y2: 426.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_157_1107",
    x1: 214.734,
    y1: 409.649,
    x2: 202.371,
    y2: 426.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_157_1107",
    x1: 90.5367,
    y1: 409.662,
    x2: 78.1743,
    y2: 426.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_157_1107",
    x1: 52.6136,
    y1: 409.661,
    x2: 40.2512,
    y2: 426.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_157_1107",
    x1: 127.898,
    y1: 399.545,
    x2: 128.25,
    y2: 438.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#35355E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2D2D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1F1F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_1107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 464,
    fill: "white",
    transform: "translate(0 0.970825)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleSms);
export default __webpack_public_path__ + "static/media/Wholesale-SMS.662a1eb32cab9271661674d6802d00a0.svg";
export { ForwardRef as ReactComponent };